import { useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let loaded = false;

const TrackingScripts = () => {
  useEffect(() => {
    if (loaded) return;
    loaded = true;

    axios.get(`${API}/settings/tracking`).then(({ data }) => {
      const { fb_pixel_id, ga_measurement_id } = data;

      // Google Analytics (gtag.js)
      if (ga_measurement_id) {
        const gaScript = document.createElement('script');
        gaScript.async = true;
        gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${ga_measurement_id}`;
        document.head.appendChild(gaScript);

        const gaInit = document.createElement('script');
        gaInit.textContent = `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${ga_measurement_id}');
        `;
        document.head.appendChild(gaInit);
      }

      // Facebook Pixel
      if (fb_pixel_id) {
        const fbInit = document.createElement('script');
        fbInit.textContent = `
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '${fb_pixel_id}');
          fbq('track', 'PageView');
        `;
        document.head.appendChild(fbInit);

        const fbNoscript = document.createElement('noscript');
        const fbImg = document.createElement('img');
        fbImg.height = 1;
        fbImg.width = 1;
        fbImg.style.display = 'none';
        fbImg.src = `https://www.facebook.com/tr?id=${fb_pixel_id}&ev=PageView&noscript=1`;
        fbNoscript.appendChild(fbImg);
        document.body.appendChild(fbNoscript);
      }
    }).catch(() => {});
  }, []);

  return null;
};

export default TrackingScripts;
